import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)
import NavBar from '@/components/NavBar.vue'
Vue.use(VueRouter);
Vue.component('nav-bar', NavBar);
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/classify',
    name: 'classify',
    component: () => import(/* webpackChunkName: "about" */ '../views/ClassifyView.vue')
  },
  {
    path: '/display',
    name: 'display',
    component: () => import(/* webpackChunkName: "about" */ '../views/DisplayView.vue')
  },
  {
    path: '/displayinfo:id',
    name: 'displayinfo',
    component: () => import(/* webpackChunkName: "about" */ '../views/DisplayInfo.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsView.vue')
  },
  {
    path: '/newsinfo:id',
    name: 'newsinfo',
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsInfo.vue')
  },
  {
    path: '/serveview',
    name: 'serveview',
    component: () => import(/* webpackChunkName: "about" */ '../views/ServeView.vue') 
  },
  {
    path: '/myview',
    name: 'myview',
    component: () => import(/* webpackChunkName: "about" */ '../views/MyView.vue') 
  },
  
  
  
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})
export default router
